module.exports = __webpack_public_path__ + "static/img/85a371d.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/sendPoints/pic1.png
// module id = 686
// module chunks = 2